import { Component } from 'react';

import CustomLinkButton from "GeneralComponents/CustomLinkButton"
import CarouselItem from "../Carousel.interface"
import Helper from 'Interfaces/Helper'
import LimitedContent from 'GeneralComponents/LimitedContent'

import "./MiniNews.css"

export default class MiniNewsICarouselItem extends Component {
    props: any;
    state: CarouselItem

    constructor(props) {
        super(props);

        this.state = {
            ...this.props.carouselItem
        }
    }

    render() {
        return (
            <div className="miniNews_carousel_item" >
         {/*information*/}
         {/*title*/}
                <h3 className="info_title clamp txt-pallete-color">{this.state.title}</h3>
        {/*information from RichDescription or Content if RichDescription not available*/}
                <div className="info_description_placeholder">
                    {this.state.richDescription ? <LimitedContent htmlContent={this.state.richDescription} classNames="info_description clamp" /> :
                        <LimitedContent htmlContent={this.state.content} classNames="info_description clamp" />}
                </div>
        {/*link*/}
                <div className="link_placeholder">
                    <CustomLinkButton
                        pageUrl={this.state.url}
                        link={this.state.link}
                        isBtn={false}
                        linkClass={"link txt-pallete-color clamp"}
                        dir={this.props.dir}
                        linkIcon={true}
                        charLimit={30}
                    />
                </div>
            </div>       
        )
    }
}